<template>
  <div class="resident-warpper">
    <div class="bg-white" v-if="jumin">
      <table class="detail-table">
        <tr>
          <td colspan="4" class="active">
            <div class="flex align-center justify-between">
              <div></div>
                服务对象明细表
              <el-button
                size="small"
                type="warning"
                @click="exportServedPeopleDetail"
              >导出
              </el-button>
            </div>
          </td>
        </tr>
        <tr>
          <td>姓名：{{ jumin.name }}</td>
          <td>手机号：{{ jumin.phone }}</td>
          <td>社区名称：{{ jumin.xiaoqu_name }}</td>
          <td>楼门户：{{ jumin.building_name }}-{{ jumin.element_name }}-{{ jumin.room_name }}</td>
        </tr>
        <tr>
          <td>申请完成的服务项数：{{ jumin.service_num }}</td>
          <td>支付积分：{{ jumin.pay_num }}</td>
          <td colspan="2">剩余积分：{{ jumin.integral }}
            <el-button type="primary" icon="el-icon-edit" class="margin-left" round size="medium"
                       @click="scoreDialog=true"></el-button>
          </td>
        </tr>
      </table>

      <el-table
        :data="jumin.integral_log"
        header-row-class-name="table-header"
        row-class-name="table-row"
        alig="center"
        border
        style="width: 100%"
      >
        <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
        <el-table-column label="操作内容" prop="content"></el-table-column>
        <el-table-column label="时间" prop="create_time"></el-table-column>
        <el-table-column label="积分" prop="integral"></el-table-column>
        <el-table-column label="说明" prop="reason">
          <template slot-scope="scope">
            <div class="table-operate" v-if="Number(scope.row.type) !== 2">
              {{ scope.row.reason }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <div class="table-operate">
              <el-button
                v-if="Number(scope.row.type) === 2"
                size="small"
                type="primary"
                @click="detailItem(scope.row.id)"
              >查看
              </el-button>

            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="jumin && jumin.integral_log.length > 0"
        class="page-all"
        background
        @current-change="getDetail"
        :current-page.sync="page"
        :page-size="limit"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>

    </div>
    <editScoreDialog
      :score="jumin?jumin.integral:0"
      :scoreDialog="scoreDialog"
      @cancelDialog="cancelDialog"
    />
    <serveMunePopleDialog
      :serverMune="serverMune"
      :serverMuneDialog="serverMuneDialog"
      @cancelDialog="cancelDialog"
    />
  </div>
</template>

<script>
import { exportServedPeopleDetail, getServedPeopleDetail} from "@/api/weilao";
import editScoreDialog from "@/views/pages/sndialog/editScoreDialog";
import serveMunePopleDialog from "@/views/pages/sndialog/serveMunePopleDialog";

export default {
  name: "server-pople-detail",
  data() {
    return {
      page: 1,
      limit: 10,
      total: 0,
      jumin: null,
      scoreDialog: false,
      serverMuneDialog: false,
      serverMune: 0,

    }
  },
  created() {
    this.$emit("setIndex", '/home/server-pople', "双暖为老 / 服务对象详情", true);
    this.getDetail()
  },
  components: {
    editScoreDialog,serveMunePopleDialog
  },
  methods: {
    //  居民导出
    async exportServedPeopleDetail(){
      let _state = await exportServedPeopleDetail(
        this.$route.params.id
      )
      let blob = _state.data
      var downloadElement = document.createElement('a');
      var href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.style.display = 'none';
      downloadElement.href = href;
      downloadElement.setAttribute('download', this.jumin.name + '明细表.xls');
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
    },
    detailItem(id) {
      this.serverMune = id
      this.serverMuneDialog = true
    },
    //  获取详情
    async getDetail() {
      let _data = await getServedPeopleDetail(this.$route.params.id, this.page, this.limit)
      this.jumin = _data.data
      this.total = _data.total_number
    },
    cancelDialog() {
      this.scoreDialog = false
      this.serverMuneDialog = false
      this.serverMune = 0
      this.getDetail()
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.detail-table {
  width: 100%;
  border-top: 1px solid #c2ccd1;
  border-left: 1px solid #c2ccd1;

  td {
    border-bottom: 1px solid #c2ccd1;
    border-right: 1px solid #c2ccd1;
    padding: 20px;
    text-align: center;
    vertical-align: center;
    font-size: 16px;
    background: rgba(#f3b861, .5);
    //color: #fff;
  }
}
</style>
